<div *ngIf="data && data.length == 0" class="w-100 d-flex flex-column align-items-center justify-content-start {{classes}}">
  <img src="../../../../assets/media/no-data-placeholder.png" alt="No Data">
  <p class="no-data-label">{{'SHARED.NO_DATA' | translate}}</p>
</div>
